// src/components/ui/calendar/month/MonthHeaderRow/MonthHeaderRow.jsx
import React from 'react';
import { cn } from '../../../../../utils/cn';

const MonthHeaderRow = ({
  dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  className = ''
}) => {
  return (
    <div className={cn(
      // Exact styling from your current MonthView + normalized height
      "grid grid-cols-7 bg-slate-800/40 border-b border-slate-600/30 h-12",
      className
    )}>
      {dayNames.map((day) => (
        <div
          key={day}
          className="p-2 text-center text-xs font-semibold text-slate-400 border-r border-slate-600/30 last:border-r-0 flex items-center justify-center"
        >
          {day}
        </div>
      ))}
    </div>
  );
};

export default MonthHeaderRow;